export const companyTable = {
  header: 'Companies',

  id: 'Company ID',
  name: 'Display Name',
  status: 'Account Holder Status',
  merchantId: 'Google Pay Merchant ID',
  feeStructure: 'Fee Structure',

  empty: 'This client has no company assigned',
  createCompany: 'Create Company',
  searchPlaceholder: 'Search company name',
  syncStripeAccount: 'Sync a Stripe account',
};
